import api from "../services/api";
import { ILocation } from "../models/ILocation";
import { IServiceResponse } from "../types/api";

export const getAllLocations = (): Promise<IServiceResponse<ILocation[]>> => 
  api.get("Location");

export const getLocationById = (id: string): Promise<IServiceResponse<ILocation>> => 
  api.get(`Location/${id}`);

export const createLocation = (data: { 
  name: string; 
  googleMapsLink?: string; 
}): Promise<IServiceResponse<ILocation>> => 
  api.post("Location", data);

export const updateLocation = (
  id: string, 
  data: { name?: string; googleMapsLink?: string | null }
): Promise<IServiceResponse<ILocation>> => 
  api.put(`Location/${id}`, data);

export const deleteLocation = (id: string): Promise<IServiceResponse<boolean>> => 
  api.delete(`Location/${id}`);

export const searchLocations = (searchTerm: string): Promise<IServiceResponse<ILocation[]>> => 
  api.get(`Location/search?searchTerm=${encodeURIComponent(searchTerm)}`);

